var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAnimationFrame } from "./sensors/animationFrame";
export function useAnimationFrameThrottle(animationFramePriority = 0) {
    let lastCallback = null;
    const throttle = (callback) => {
        lastCallback = callback;
    };
    useAnimationFrame(() => {
        if (lastCallback) {
            lastCallback();
            lastCallback = null;
        }
    }, animationFramePriority);
    return {
        throttle,
    };
}
/**
 * Throttles a function with a timeout in milliseconds.
 * Will call the provided function immediately, and subsequent throttle calls
 * only after provided timeout period. Unlike the equivalent function from VueUse,
 * this will always call the last provided callback eventually.
 */
export function useTimeoutThrottle(timeout = 100) {
    let lastCallback = null;
    let pendingTimeout = false;
    const throttle = (callback) => {
        lastCallback = callback;
        run();
    };
    const run = () => __awaiter(this, void 0, void 0, function* () {
        const nextCallback = lastCallback;
        if (!pendingTimeout && nextCallback) {
            pendingTimeout = true;
            lastCallback = null;
            yield nextCallback();
            setTimeout(() => {
                pendingTimeout = false;
                run();
            }, timeout);
        }
    });
    return {
        throttle,
    };
}
